<template>
  <el-dialog
    width="1200px"
    title="选择优惠券"
    :visible="visible"
    @close="close"
  >
  <div slot="title" >
    <span style="font-size:18px">选择优惠券</span>
    <span class="form-red">优惠券设置路径为优惠券管理->发放优惠券，仅展示发放规则为【活动发放】的优惠券</span>
  </div>
    <div class="table-panel flex item-center flex-end">
      <el-select
        class="mr10"
        size="small"
        clearable
        placeholder="选择发放对象"
        v-model="searchCondition.sendTarget"
      >
        <el-option
          v-for="(item, i) in sendTargetOption"
          :key="i"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        clearable
        placeholder="选择会员类型"
        v-model="searchCondition.isPlus"
        style="width: 150px"
        class="mr10"
      >
        <el-option
          v-for="item in members"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        class="mr10"
        size="small"
        clearable
        placeholder="输入发放名称/副标题查询"
        v-model.trim="searchCondition.keywords"
        style="width: 250px"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table mb20">
      <el-table
        stripe
        border
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        max-height="400"
      >
        <el-table-column
          type="selection"
          :selectable="selectEnable"
        ></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="发放名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          show-overflow-tooltip
          label="副标题"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendWayTypeFormat"
          label="发放类型"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="发放时间"
          width="200"
        >
          <template slot-scope="scope">
            {{
              `${scope.row.sendStartDate} ${
                scope.row.sendStartTime.split(",")[0]
              }`
            }}<br />
            至{{
              `${scope.row.sendEndDate} ${scope.row.sendEndTime.split(",")[0]}`
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendNumFormat"
          label="发放数量"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusFormat"
          label="状态"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <span slot="footer" class="dialog-footer flex flex-center">
      <el-button size="small" type="primary" @click="save">确 定</el-button>
      <el-button size="small" @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    enabelList: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      members: [{ name: "PLUS会员", value: 0 }, { name: "全部会员", value: 1 }],
      sendTargetOption: [
        {
          value: 0,
          label: "所有用户"
        },
        {
          value: 1,
          label: "指定用户"
        },
        {
          value: 2,
          label: "指定导购"
        },
        {
          value: 3,
          label: "指定门店"
        }
      ],
      searchCondition: {},
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      checkedRowList: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    selectEnable(row) {
      if (
        this.enabelList.some(item => item.couponSendId === row.couponSendId)
      ) {
        return false;
      } else {
        return true; // 不禁用
      }
    },

    save() {
      if (this.checkedRowList.length) {
        this.$emit("save", this.checkedRowList);
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$message({
          message: "请选择发放优惠券",
          type: "warning"
        });
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      //仅活动发放且是发放中的优惠券
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        sendWayType: 4,
        status: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);

      const { code, result } = await this.$store.dispatch(
        "querySendCoupons",
        params
      );
      if (code === 0) {
        const { records, total } = result;

        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleSelectionChange(row) {
      this.checkedRowList = row;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    close() {
      this.$refs.multipleTable.clearSelection();
      this.$emit("close");
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
